module.exports = __webpack_public_path__ + "assets/img/block-right-03487610.png";